import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './../store';
import home from './../pages/Accueil/Accueil.vue';
import famille from './../pages/Famille/Famille.vue';
import article from './../pages/Article/Article.vue';
import panier from './../pages/Panier/Panier.vue';
import profil from './../pages/Profil/Profil.vue';
import confirmation from './../pages/Confirmation/Confirmation.vue';
import commandes from './../pages/Commandes/Commandes.vue'
import mentionslegales from './../pages/MentionsLegales/MentionsLegales.vue'

Vue.use(VueRouter)

const routes = [{
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    component: home
  },
  {
    path: '/plaques',
    component: famille,
    meta: {
      param: 'PLA.',
      titre: "Plaques"
    }
  },
  {
    path: '/plaques/:slugArticle',
    name: 'plaques',
    component: article,
  },
  {
    path: '/fleurs',
    component: famille,
    meta: {
      param: 'FLE.',
      titre: "Fleurs"
    }
  },
  {
    path: '/fleurs/:slugArticle',
    name: 'fleurs',
    component: article,
  },
  {
    path: '/accessoires',
    component: famille,
    meta: {
      param: 'ACCESSOIRE.',
      titre: "Accessoires"
    }
  },
  {
    path: '/accessoires/:slugArticle',
    name: 'accessoires',
    component: article,
  },
  {
    path: '/inter',
    component: famille,
    meta: {
      param: 'INTER.',
      titre: "Inter"
    }
  },
  {
    path: '/inter/:slugArticle',
    name: 'inter',
    component: article,
  },
  {
    path: '/bronze',
    component: famille,
    meta: {
      param: 'BRONZE.',
      titre: "Bronze"
    }
  },
  {
    path: '/bronze/:slugArticle',
    name: 'bronze',
    component: article,
  },
  {
    path: '/panier',
    component: panier,
    meta: {
      param: '',
      titre: "Panier"
    }
  },
  {
    path: '/profil',
    component: profil,
    meta: {
      param: '',
      titre: "profil"
    }
  },
  {
    path: '/confirmation',
    component: confirmation,
    meta: {
      param: '',
      titre: "confirmation"
    }
  },
  {
    path: '/commandes',
    component: commandes,
    meta: {
      param: '',
      titre: "commandes"
    }
  },
  {
    path: '/mentionslegales',
    component: mentionslegales,
    meta: {
      param: '',
      titre: "mentionslegales"
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  history: true,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})

router.beforeEach((to, from, next) => {
    // Check if user is loggin
    if (window.$cookies.isKey("_token")) {
      next();
    } else {
      window.location.replace('/pre-login')
    }

})

export default router